import { render, staticRenderFns } from "./AgoraAdvancedJsonSection.vue?vue&type=template&id=5e1f8212&scoped=true"
import script from "./AgoraAdvancedJsonSection.vue?vue&type=script&lang=js"
export * from "./AgoraAdvancedJsonSection.vue?vue&type=script&lang=js"
import style0 from "./AgoraAdvancedJsonSection.vue?vue&type=style&index=0&id=5e1f8212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1f8212",
  null
  
)

export default component.exports